import AppRoutes from './common/AppRoutes';
import { ROUTES, ROUTE_PREFIXES } from 'common/constants/urls';

const getRoute = path => {
  const route = AppRoutes.find(route => route.path === path);
  if (!route) throw new Error(`Route not found for path: ${path}`);
  const routePathTokens = route.path.split('/');
  const routeKey = routePathTokens[routePathTokens.length - 1];
  return {
    name: route.name,
    icon: route.icon,
    key: routeKey,
    route: route.path,
    component: route.element,
    type: 'navItem',
  };
};

const sidebarRoutes = [
  getRoute(ROUTES.HOME),
  getRoute(ROUTES.PROJECTS),
  {
    type: 'collapse',
    name: 'Reports',
    key: ROUTE_PREFIXES.REPORTS,
    icon: 'query_stats',
    collapse: [getRoute(ROUTES.CA_REPORTS), getRoute(ROUTES.CC_REPORTS), getRoute(ROUTES.QCC_REPORTS)],
  },
  getRoute(ROUTES.LINEITEMS),
];

export default sidebarRoutes;
